import { memo } from 'react';

import { useErrorTranslations } from '@/hooks';
import { ForbiddenError } from '@/lib/errors';

import { Error } from './Error';

export type ErrorPageProps = {
  error: unknown;
};

export const ErrorPage = memo(function ErrorPage({ error }: ErrorPageProps) {
  const errorTranslations = useErrorTranslations();

  if (error instanceof ForbiddenError) {
    return (
      <Error
        statusCode={403}
        title={errorTranslations['403'].title}
        description={errorTranslations['403'].message}
      />
    );
  }

  return (
    <Error
      statusCode={500}
      title={errorTranslations['500'].title}
      description={errorTranslations['500'].message}
    />
  );
});
